module.exports = __webpack_public_path__ + "img/nba21.b1952c7e.png";